import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditUserPageNew from "../../components/User/EditUserPageNew";





const EditUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="User" link2="/user" title="Edit User" />

        {/* AddUserLayer */}
        <EditUserPageNew />


      </MasterLayout>
    </>
  );
};

export default EditUserPage;
